<template>
	<div class="gradeBox">
		<div class="gradeBox-m1">
			<span class="gradeBox-m1-txt">当前比赛轮次：</span>
			<van-dropdown-menu>
			  <van-dropdown-item v-model="value1" :options="option1" @change="onChange" />
			</van-dropdown-menu>
		</div>
		<div class="gradeList">
			<div class="item" v-for="(item, index) in list">
				<div class="item-m1">
					第<span>{{ index + 1 }}</span>组
				</div>
				<div class="item-m2">
					<div class="item-m2-title">
						{{ item.text }}
					</div>
					<div class="item-m2-person">
						<div class="person1">
							<div class="person1-num">{{ item.person[0].number }}</div>
							<div class="person1-name">{{ item.person[0].name }}</div>
						</div>
						<div class="person-vs">
							<img src="https://oss.mcloud.moveclub.cn/mpmsalpha/20210228/1614485877-603b1975e867e.png" alt="">
							<div>{{ item.lun }}</div>
						</div>
						<div class="person1">
							<div class="person1-num">{{ item.person[1].number }}</div>
							<div class="person1-name">{{ item.person[1].name }}</div>
						</div>
					</div>
					<div class="score">
						<div class="score-m1">
							<div v-if="item.person[0].isshowscore == false" class="score-m1-text" :data-index="index" @click="focusScore(index, 0)">
								<div class="txt1">--</div>
								<div class="txt2">请输入比分</div>
							</div>
							<div v-else class="score-m1-text2">
								<input ref="myInput1" v-model="item.person[0].score" type="text" :autofocus="item.person[0].isfocus" @blur="sendScore(index, 0)" @input="inputScore(index, 0, $event)">
							</div>
							
						</div>
						<div class="score-label">:</div>
						<div class="score-m1">
							<div v-if="item.person[1].isshowscore == false" class="score-m1-text" :data-index="index" @click="focusScore(index, 1)">
								<div class="txt1">--</div>
								<div class="txt2">请输入比分</div>
							</div>
							<div v-else class="score-m1-text2">
								<input ref="myInput2" v-model="item.person[1].score" type="text" :autofocus="item.person[1].isfocus" @blur="sendScore(index, 1)" @input="inputScore(index, 1, $event)">
							</div>
						</div>
					</div>
					
					
					
				</div>
			</div>
			
		</div>
		
	</div>
</template>

<script>
export default {
  data() {
    return {
      value1: 1,
      option1: [],
			
			// matchid: 5511,
			// trackid: 146,
			// matchid: 8476,
			// trackid: 185,
			matchid: "",
			trackid: "",
			// list: [{
			// 	id: 1,
			// 	text: '女子单打赛',
			// 	lun: '第一轮',
			// 	person: [{
			// 		uid: 1,
			// 		number: 'A001',
			// 		name: '段莹莹/段莹莹1',
			// 		score: '',
			// 		isshowscore: false,
			// 	},{
			// 		uid: 1,
			// 		number: '--',
			// 		name: '--',
			// 		score: '',
			// 		isshowscore: false,
			// 	}]
			// },{
			// 	id: 1,
			// 	text: '女子单打赛',
			// 	lun: '第一轮',
			// 	person: [{
			// 		uid: 1,
			// 		number: 'A001',
			// 		name: '段莹莹/段莹莹3',
			// 		score: '0',
			// 		isshowscore: true,
			// 	},{
			// 		uid: 1,
			// 		number: 'A001',
			// 		name: '段莹莹/段莹莹4',
			// 		score: '',
			// 		isshowscore: false,
			// 	}]
			// }]
			list: []
			
    };
  },
	
	mounted() {
		let _this = this
		
		console.log("this.$route", this.$route)
		this.matchid = this.$route.query.matchid
		this.trackid = this.$route.query.trackid
		var data = {
			matchid: this.matchid,
			trackid: this.trackid,
		}
		
		this.$api.rank
			.getRankLName(data)
			.then((res) => {
				if (res.status * 1 === 200) {
					let arr = []
					res.data.forEach((item, index) => {
							let itembak = {
								text: item.menuname,
								value: item.type
							}
							arr.push(itembak)
					})
					_this.option1 = arr
					_this.value1 = _this.option1[0].value
					let param = {
						matchid: _this.matchid,
						trackid: _this.trackid,
						type: _this.value1
					}
					this.getRankList(param)
				}
				// this.$toast.clear();
			});
	},
	methods:{
		onChange(val){
			this.value1 = val
			let param = {
				matchid: this.matchid,
				trackid: this.trackid,
				type: this.value1
			}
			this.getRankList(param)
		},
		getRankList(data){
			var _this = this;
			this.$api.rank.getRankList2(data).then(res => {
				if (res.status == 200 && res.data) {
					var arr = []
					res.data.forEach((item, index) => {
						if(item.enrollinfo.length == 0){
							var person = [{
								number: '--',
								name: '--',
								score: '',
								isshowscore: false,
								isfocus: false,
							},{
								number: '--',
								name: '--',
								score: '',
								isshowscore: false,
								isfocus: false,
							}]
						}
						if(item.enrollinfo.length == 1){
							var person = [{
								number: item.enrollinfo[0].number,
								name: item.enrollinfo[0].name,
								score: item.enrollinfo[0].ischeckin == '2' ? '' : Number(item.enrollinfo[0].score),
								isshowscore: item.enrollinfo[0].ischeckin == '2' ? false : true,
								isfocus: false,
							},{
								number: '--',
								name: '--',
								score: '',
								isshowscore: false,
								isfocus: false,
							}]
						}
						if(item.enrollinfo.length == 2){
							var person = [{
								number: item.enrollinfo[0].number,
								name: item.enrollinfo[0].name,
								score: item.enrollinfo[0].ischeckin == '2' ? '' : Number(item.enrollinfo[0].score),
								isshowscore: item.enrollinfo[0].ischeckin == '2' ? false : true,
								isfocus: false,
							},{
								number: item.enrollinfo[1].number,
								name: item.enrollinfo[1].name,
								score: item.enrollinfo[1].ischeckin == '2' ? '' : Number(item.enrollinfo[1].score),
								isshowscore: item.enrollinfo[1].ischeckin == '2' ? false : true,
								isfocus: false,
							}]
						}
						let itemBak = {
							text: '女子单打赛',
							lun: item.groupname.split('-')[0],
							groupnum: item.groupnum,
							person: person
						}
						
						arr.push(itemBak)
						
					})
					_this.list = arr
					
					
				}
			});
		},
		
		inputScore(index, n, e){
			var reg = /^(\d{0,6})(\.(\d{0,2}))?$/g;
			if (!reg.test(e.data)) {
				console.log("4444", e.data, this.list[index].person[n].score)
				this.list[index].person[n].score = ''
			}
			console.log("4444", e.data)
		},
		
		focusScore(index, per){
			var _this =  this
			let pidx = per * 1	
			if(this.list[index].person[pidx].name == '--'){
				// 还没有人员时				
				this.$toast.fail('暂无人员可以打分');
				return ;
			}
			this.list[index].person[pidx].isshowscore = true
			// // this.list[index].person[pidx].isfocus = true
			// this.list.forEach((item, index2) => {
			// 	item.person.forEach((item3, index3) => {
			// 		item3.isfocus = false
			// 	})
			// })
			// this.list.forEach((item, index2) => {
			// 	if(index == index2){
			// 		item.person.forEach((item3, index3) => {
			// 			if(pidx == index3){
			// 				item3.isfocus = true
			// 			}
			// 		})
			// 	}
			// })
			this.$nextTick(() => {
				if(pidx == 1){
					this.$refs.myInput2[this.$refs.myInput2.length - 1].focus()
					
				}else{
					this.$refs.myInput1[this.$refs.myInput1.length - 1].focus()
				}
			})
			
			
			
			// console.log("8888", this.$refs.myInput1[per])
			
		},
		sendScore(index, n){
			
			console.log("88888", this.list[index].person[n].score) 
			if(this.list[index].person[n].score == '' && this.list[index].person[n].score != "0"){
				this.list[index].person[n].isshowscore = false				
			}else{
				var data = {
					matchid: this.matchid,
					trackid: this.trackid,
					groupnum: this.list[index].groupnum,
					number: this.list[index].person[n].number,
					score: this.list[index].person[n].score,
				}
				this.$api.rank
					.editScore(data)
					.then((res) => {
						if (res.status * 1 === 200) {
							
						}
						// this.$toast.clear();
					});
				// matchid, trackid, groupnum, number, score
			}
		},
	}
	
	
};
</script>

<style scoped>
.gradeBox-m1 >>> .van-dropdown-menu__bar{
	height: .48rem;
	background: #F7F7F7;
	box-shadow: none;
	width: 100%;
}	
.gradeBox-m1 >>> .van-dropdown-menu__item{
	text-align: left;
	justify-content: flex-start;
}	

.gradeBox-m1 >>> .van-dropdown-menu{
	background: #F7F7F7;
	height: .64rem;
	display: flex;
	justify-content: space-between;
	align-items: center;
	flex-grow: 1;
}

.gradeBox-m1 >>> .van-dropdown-menu__title{
	width: calc(100% - .4rem);
	/* box-sizing: border-box; */
	/* padding-right: calc(100% - .5rem); */
}

.gradeBox-m1 >>> .van-dropdown-menu__title::after{
	border-color: transparent transparent #1989fa #1989fa;
}

.gradeBox{
	
}
.gradeBox-m1{
	/* box-sizing: border-box; */
	padding: .3rem .3rem 0 .3rem;
	display: flex;
	height: .48rem;
	line-height: .48rem;
	align-items: center;
}
.gradeBox-m1-txt{
	font-size: .30rem;
	color: rgba(0,0,0,0.50);
	margin-right: .3rem;
}
.gradeList{
	box-sizing: border-box;
	padding-bottom: .5rem;
}
.item{
	margin-top: .4rem;
}
.item-m1{
	width: 100%;
	box-sizing: border-box;
	padding: .2rem .5rem;
	background: #FAFAFA;
	font-size: .264rem;
	color: rgba(0,0,0,0.85);
	display: flex;
	align-items: center;
}
.item-m1 span{
	width: .38rem;
	height: .38rem;
	display: inline-block;
	/* padding: .05rem; */
	background: #666666;
	color: #fff;
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 0 .05rem;
	border-radius: .05rem;
}
.item-m2-title{
	width: 100%;
	text-align: center;
	font-size: .28rem;
	padding: .15rem 0 .05rem 0;
	color: rgba(0,0,0,0.25);
}

.item-m2-person{
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: calc(100% - 1rem);
	margin: auto;
}
.score{
	display: flex;
	justify-content: space-between;
	align-items: center;
	width: calc(100% - 1rem);
	margin: auto;
	margin-top: .2rem;
}
.score-m1{
	width: 2.7rem;
	text-align: center;
	background: #FAFAFC;
	border: .01rem solid #E8E9EC;
	border-radius: .0978rem;
	height: 2.24rem;
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	box-sizing: border-box;
}
.score-m1-text2{
	width: 100%;
	height: 2.24rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: center;
}
.score-m1-text2 input{
	width: 100%;
	height: 2.18rem;
	text-align: center;
	box-sizing: border-box;
	border-radius: .0978rem;
	border: none;
	outline: none;
	font-size: .9rem;
}

.score-m1-text2 input:focus{
	/* border-color: #4BA7FD;s */
	border: .01rem solid #4BA7FD;
	border-radius: .0978rem;
	box-sizing: border-box;
}

.txt1{
	font-size: .567rem;
	color: #324357;
}
.txt2{
	font-size: .36rem;
	color: #D7DADE;
	margin-top: .2rem;
}
.score-label{
	width:calc(100% - 5.4rem);
	text-align: center;
	font-size: .8261rem;
	color: #324357;
}
.person1{
	width: 2.7rem;
	text-align: center;
}
.person-vs{
	width:calc(100% - 5.4rem)
}
.person1-num{
	font-weight: bold;
	font-size: .52rem;
	color: #4BA7FD;
}
.person1-name{
	font-size: .28rem;
	color: rgba(0,0,0,0.85);
	margin-top: .13rem;
}
.person-vs{
	text-align: center;
	/* width: ; */
	/* height: .72rem; */
}
.person-vs img{
	width: .72rem;
	height: .72rem;
}
.person-vs div{
	font-size: .28rem;
	color: rgba(0,0,0,0.25);
}
</style>
